import NamedDto from 'modules/base/dto/NamedDto';

export class ModelEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {number} */
		this.driver = null;

		/** @type {string} */
		this.version = null;

		/** @type {string} */
		this.image = null;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _ModelEditDtoProps
	 * @property {string} type
	 * @property {number} driver
	 * @property {string} version
	 * @property {string} image
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ModelEditDtoProps} ModelEditDtoProps
	 */
	/**
	 *
	 * @param {ModelEditDtoProps} props
	 * @returns {ModelEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.driver = props.driver;
		this.version = props.version;
		this.image = props.image;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default ModelEditDto;